
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../../context/GlobalContext';
import AccessibleContent from '../../utils/AccessibleContent';

const DetailFooter = () => {
    const { t } = useTranslation();



    const {
        store,
        selectedLang
    } = useGlobalContext()

    const lang = selectedLang || 'en'

    return (
        <div className="content">
            <div id="topSection">
                <div className={`overlayBox ${store.mainImageFilter ? 'overlay' : ''}`}>
                    <div className="wrapper">
                        <AccessibleContent
                            htmlContent={store.texteAccroche && store.texteAccroche[lang]
                                ? store.texteAccroche[lang].replace("<p>", "<h2>").replace("</p>", "</h2>")
                                : `<h2>${t("Recevez votre carte cadeau")}</h2>`}
                            className="headContent accrocheColor"
                        />
                    </div>
                </div>
            </div>

            <div className="mainContent">
                <div className="wrapper mainWhiteBox">
                    <div className="modalAction">
                        <a
                            href="/home"
                            className="buyCard returnToHome"
                        >
                            {t("Acheter une e carte cadeau")}

                        </a>
                    </div>
                    <div className="mainImg">
                        <img src={store.help?.image} alt="Help" />
                    </div>
                    <div className="contentBody mainColor">
                        <h1>{store.title1[lang]}</h1>
                        <AccessibleContent
                            htmlContent={store.editorText[lang]}
                            className="modalcontent"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailFooter;
